import React from "react";

import { Modal } from "./modal/Modal";

type UnsavedChangesModalProps = {
  open: boolean;
  message?: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  open,
  message = "Do you want to leave without savings?",
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <Modal onClose={onCancel} width={"440px"}>
      <p className={"mb-4 text-sm text-[#5F758F]"}>{message}</p>
      <div className={"mt-8 flex justify-center gap-3 text-sm font-semibold"}>
        <button
          onClick={onCancel}
          className={
            "w-full rounded-lg border border-[#C8D2DE] px-4 py-2 text-[#253747] disabled:opacity-75"
          }>
          No
        </button>
        <button
          onClick={onConfirm}
          className={
            "flex w-full justify-center rounded-lg bg-[#6938EF] px-4 py-2 text-white disabled:opacity-75"
          }>
          Yes
        </button>
      </div>
    </Modal>
  );
};
